// SPDX-License-Identifier: GPL-3.0-or-later
// Glue between the table characters and the SigmaBot builder (sigmabot/).
// A character is one SigmaBot plus the props that show the game state (a label, lamps, a ring).

import type { Group } from "three";
import { buildSigmaBot, frontZ, type SigmaBotSpec } from "./sigmabot/index.ts";

/** Build a SigmaBot, name it, and add it to a character group. Return the bot. */
export function addBot(parent: Group, name: string, spec: SigmaBotSpec, scale: number): Group {
  const bot = buildSigmaBot(spec, scale);
  bot.name = name;
  parent.add(bot);
  return bot;
}

/**
 * The z of the front surface of the bot in table units, at a height `y` and a sideways position
 * `x` (both in table units, measured from the foot anchor). It is 0 outside the body.
 */
export function botFront(spec: SigmaBotSpec, scale: number, y: number, x = 0): number {
  return frontZ(spec.body, y / scale, x / scale) * scale;
}
